

export const veoExamples = {
    title: 'AI Video Creative Examples - Keyframe Control & Multi‑Image References',
    sub:
      'Explore advanced models for video generation with keyframe control, multi‑image references, and native audio. From images to cinematic videos, experience the infinite possibilities of AI video creation.',
    originalImage: 'Original Image',
    generatedVideo: 'AI Generated Video',
    pill: 'AI Video'
  };
